export const getSavedReportURLByReportType = (reportType, reportId) => {
	return '/saved-report/' + reportType.toLowerCase().replace(/ /g, '-') + '/' + reportId;
};
